import request, { apiURL } from '../utils/api';
class NavigationOptionsService {
  getAll() {
    const options = {
      headers: {
        Authorization: import.meta.env.REACT_APP_TEMP_TOKEN,
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/navigationOptions`, options);
  }
}

export default NavigationOptionsService;
